<template>
  <div class="table-poptip">
    <div v-if="content && content.length > showPoptipsContentLength">
      <Poptip
        word-wrap
        :width="content.length > 200 ? 600 : 300"
        :transfer="true"
        trigger="hover"
        :content="content"
        popper-class="inner-poptip-scroll"
      >
        <div class="flex align-items">
          <slot name="left"></slot>
          <span class="cursor-pointer content-text"> {{ content }}</span>
        </div>
      </Poptip>
    </div>

    <div v-else class="flex align-items" :style="{ width: contentWidth + 'px' }">
      <slot name="left"></slot>
      <span class="content-text">{{ content ? content : '--' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablePoptip',
  props: {
    content: {
      type: String,
      default: ''
    },
    // 文本字数超过多少就要展示气泡提示
    showPoptipsContentLength: {
      type: Number,
      default: 13
    },
    contentWidth: {
      type: Number,
      default: 210
    }
  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {
    getDesc(desc) {
      return desc.length > 14 ? desc.substring(0, 12) + '...' : desc;
    }
  }
};
</script>

<style lang="scss">
.table-poptip {
  .content-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
  .ivu-poptip {
    width: 100%;
    .ivu-poptip-rel {
      width: 100%;
    }
  }
}
.inner-poptip-scroll {
  .ivu-poptip-body-content-inner {
    max-height: 300px;
    scrollbar-width: thin;
    overflow-y: auto;
  }
  .ivu-poptip-body-content-inner::-webkit-scrollbar {
    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .ivu-poptip-body-content-inner::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 6px;
    box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
    background: #535353;
  }
  .ivu-poptip-body-content-inner::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    background: #ededed;
  }
}
</style>
